import req from '../../api/request'

/**
 * Fetches a single team's full detail payload.
 *
 * Used where a caller holds only a partial team (an operations tree node, a
 * grid row) but needs everything the edit form writes back — images, contact
 * fields, visibility flags. Seeding an edit form from a partial object means
 * the missing fields render blank and are then PUT back as defaults, quietly
 * wiping them.
 */
export const getTeam = async (teamId: string): Promise<unknown> => {
  const { data } = await req(`/teams/${teamId}`)
  return data
}
